export const VideoConstants = {
  ONE_FRAME: 1 / 59.94
};
